import { PUBLIC_FEATURE_FLAGS_RECEIVED } from './constants/ActionTypes';
export const setPublicFeatureFlags = payload => {
  return {
    type: PUBLIC_FEATURE_FLAGS_RECEIVED,
    payload
  };
};